// src/pages/fleet/master/DistrictMasterPage.tsx — District master (LGD reference list).
//
// Read-only, for the same reason as the State master: IFMS validates
// destinationDistrictCode against the government's list, so the only district
// codes worth holding are the government's. 784 rows, searchable and filterable
// by state, which is how an operator checks what a dealer's district resolves to.
import React from 'react';
import MasterTable from './MasterTable';
import useLgd, { LgdDistrict, stateNameOf, stateOptions } from './useLgd';

export default function DistrictMasterPage() {
  const { states, districts, loading, error } = useLgd();

  return (
    <MasterTable<LgdDistrict>
      icon="pin" title="District" subtitle="LGD district codes, grouped by state"
      idKey="code" rows={districts} addLabel="District"
      banner={error
        ? error
        : <><b>Government reference list.</b> All {districts.length || 784} districts published by lgdirectory.gov.in.
            IFMS receives the LGD District Code as <code>destinationDistrictCode</code>; a dealer's district is set in
            Master → Vendor and the code is filled in from this list automatically.</>}
      emptyText={loading ? 'Loading the LGD list…' : 'The LGD list could not be loaded'}
      searchKeys={['name', 'code']}
      filters={[{ key: 'stateCode', label: 'State', options: stateOptions(states) }]}
      stats={[
        { label: 'Total Districts', value: districts.length, tint: 'var(--fx-accent)' },
        { label: 'States covered', value: new Set(districts.map((d) => d.stateCode)).size, tint: 'var(--fx-purple)' },
      ]}
      columns={[
        { key: 'code', label: 'LGD District Code', width: 150, render: (r) => <b style={{ fontFamily: 'DM Mono, monospace' }}>{r.code}</b> },
        { key: 'name', label: 'District Name', render: (r) => <b>{r.name}</b> },
        {
          key: 'stateCode', label: 'State',
          render: (r) => <>{stateNameOf(states, r.stateCode)} <span style={{ color: 'var(--fx-text-3)' }}>({r.stateCode})</span></>,
          csvValue: (r) => stateNameOf(states, r.stateCode),
        },
      ]}
      fields={[]}
    />
  );
}
